import { type FC } from "react"
import { Navigate, useParams } from "react-router"

import { parseNumber } from "@forento/shared/utilities/number"

import Button from "~/themes/school/components/Button"
import Layout from "~/themes/school/components/Layout"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import ProductDetail from "~/themes/school/components/ProductDetail"
import { useTranslation } from "~/translations"
import routes from "~/utilities/routes"
import { query } from "~/utilities/trpc"

const BundlePage: FC = () => {
	const t = useTranslation()

	const bundleId = parseNumber(useParams().bundleId)

	const { data, error, refetch } = query.bundle.getPersonalized.useQuery(bundleId ?? -1)

	if (data === null) {
		return <Navigate to={routes.bundle.index()} replace />
	}

	return (
		<Layout>
			{error ? (
				<p>{t("failedToLoad")}</p>
			) : !data ? (
				<PartialLoadingPage />
			) : (
				<ProductDetail
					type="bundle"
					product={data}
					reload={refetch}
					unlockedContent={
						<Button variant="primary" isDisabled>
							{t("bundle.owned")}
						</Button>
					}
				/>
			)}
		</Layout>
	)
}

export default BundlePage
